import { SBack } from 'shj-components'
import UserInfo from '../components/userInfo'
import FollowRecord from '../components/followRecord'
import { Button } from 'antd'
import { useState } from 'react'
import NewOrEditCustomer from '../modalsOrDrawers/newOrEditCustomer'
import { getAuth } from '@/utils/auth'
import { useParams } from 'react-router-dom'

const CustomerProfileDetail = () => {
  const auth = getAuth()
  const { id } = useParams()
  const [refresh, setRefresh] = useState(false)
  const [openEdit, setOpenEdit] = useState(false)
  return (
    <SBack
      title="客户详情"
      level={2}
      titleStyle={{ marginBottom: 10 }}
      gutter={0}
      extra={
        auth['infoEditBtn'] && (
          <Button type="primary" onClick={() => setOpenEdit(true)}>
            编辑
          </Button>
        )
      }
      goPath={() => {
        const params = new URLSearchParams(location.search);
        const returnUrl = params.get('returnUrl');
        if (returnUrl) {
          window.open(decodeURIComponent(returnUrl), '_self');
        } else {
          history.back()
        }
      }}
    >
      <div style={{ display: 'flex', justifyContent: 'space-between' }}>
        <UserInfo refresh={refresh} />
        <FollowRecord />
      </div>
      <NewOrEditCustomer
        open={openEdit}
        onCancel={() => setOpenEdit(false)}
        openWay="detailEdit"
        id={id as string}
        setRefresh={setRefresh}
      />
    </SBack>
  )
}

export default CustomerProfileDetail
